import { Region } from '@/features/auth';
import { sentryCaptureException } from '@/utils/sentry';
import { getAppVersion } from '@/utils/version';
import axios from 'axios';
import Cookies from 'universal-cookie';

// https://github.com/customerio/hydra/blob/187d87686f6e8010c71c03e7a8bcb29b09a4d664/hydra_api_server/router.go#L130
/**
 * @deprecated
 */
export const deprecatedApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
});

/**
 * @deprecated
 */
export const servicesApi = axios.create({
  baseURL: '/v1',
  withCredentials: true,
});

export function setServicesApiRegion(region: Region) {
  if (__CIO_ENV__ !== 'production' && __CIO_ENV__ !== 'standalone') {
    return;
  }

  let regionUrlMap = {
    [Region.US]: '',
    [Region.EU]: '',
  };

  if (__CIO_ENV__ === 'production') {
    regionUrlMap = {
      [Region.US]: 'https://us.fly.customer.io',
      [Region.EU]: 'https://eu.fly.customer.io',
    };
  } else if (__CIO_ENV__ === 'standalone') {
    regionUrlMap = {
      [Region.US]: 'https://us.fly-standalone.customer.io',
      [Region.EU]: 'https://us.fly-standalone.customer.io',
    };
  }

  // in prod envs, `VITE_API_URL` is an absolute URL, in others a relative URL
  let deprecatedApiPath = '';
  try {
    deprecatedApiPath = new URL(import.meta.env.VITE_API_URL).pathname;
  } catch {
    deprecatedApiPath = import.meta.env.VITE_API_URL;
  }

  deprecatedApi.defaults.baseURL = `${regionUrlMap[region]}${deprecatedApiPath}`;
  servicesApi.defaults.baseURL = `${regionUrlMap[region]}/v1`;
}

// Default to US for auth and calls made before an account is known
setServicesApiRegion(Region.US);

[deprecatedApi, servicesApi].forEach((api) => {
  api.interceptors.request.use(async (config) => {
    const cookies = new Cookies();
    const accessToken = cookies.get('_access');

    if (accessToken != null && accessToken !== '') {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    config.headers['x-ui-version'] = getAppVersion();

    return config;
  });
});

export function notifyOnError(error: any) {
  //TODO: show notification
  sentryCaptureException(error);
}

const workspaceIdRegex = /\/workspaces\/(\d*)(\/?|\/.*)$/;

export function getWorkspaceId(url: string) {
  const path = new URL(url).pathname;
  const result = path.match(workspaceIdRegex);
  if (result != null && result.length > 2) {
    return result[1];
  }
  return '';
}
